import { defineStore } from 'pinia'

interface IAuthError {
  title: string
  description: string
}
const STORE_NAME = 'authError'
// used to show message error at modal auth
export const useAuthError = defineStore(STORE_NAME, {
  state: (): IAuthError => ({
    title: '',
    description: ''
  }),
  persist: false,
  actions: {
    setError(description: string, title?: string): void {
      this.title = title ?? ''
      this.description = description
    }
  }
})
